exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-header{padding:5px;color:#003767;flex:1;font-family:Arial,sans-serif;font-size:small;text-transform:uppercase;text-decoration-style:solid;text-align:center}.active{background-color:#003767;color:#fff}.tabs-header{background-color:#b3b3b3;flex-direction:row}.tabs-content{background-color:#f1f1f1;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/generic/tabs/tabs.component.css
// module id = 204
// module chunks = 0